module.exports = __webpack_public_path__ + "static/media/sunday_times.a4dad368.webp";